// src/components/modals/PdfModal.jsx
import React, { useEffect } from "react";
import Modal from "react-modal";
import { X, Download } from "lucide-react";

function classNames(...xs) {
    return xs.filter(Boolean).join(" ");
}

export default function PdfModal({ open, onClose, title, pdfUrl }) {
    useEffect(() => {
        // กัน warning ของ react-modal
        // (ถ้าคุณใช้ root id อื่น เปลี่ยนตามจริง)
        Modal.setAppElement("#root");
    }, []);

    return (
        <Modal
            isOpen={open}
            onRequestClose={onClose}
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
            className="outline-none"
            overlayClassName="fixed inset-0 z-[200] bg-black/50 flex items-center justify-center p-4"
        >
            <div className="w-full max-w-[1100px] rounded-2xl bg-white shadow-2xl overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between gap-3 border-b border-slate-200 px-4 py-3">
                    <div className="text-sm font-extrabold text-slate-900">{title}</div>

                    <div className="flex items-center gap-2">
                        {/* download */}
                        {pdfUrl ? (
                            <a
                                href={pdfUrl}
                                target="_blank"
                                rel="noreferrer"
                                className={classNames(
                                    "inline-flex items-center gap-2 rounded-xl px-3 py-2",
                                    "text-xs font-semibold text-slate-800 hover:shadow-sm active:scale-[0.98]"
                                )}
                                title="ดาวน์โหลด"
                            >
                                <Download size={16} />
                                ดาวน์โหลด
                            </a>
                        ) : null}

                        <button
                            onClick={onClose}
                            className={classNames(
                                "inline-flex h-9 w-9 items-center justify-center rounded-xl",
                                "hover:shadow-sm active:scale-[0.98]"
                            )}
                            title="ปิด"
                        >
                            <X size={18} />
                        </button>
                    </div>
                </div>

                {/* Body */}
                <div className="h-[72vh] bg-slate-100">
                    {pdfUrl ? (
                        <iframe
                            title="pdf-viewer"
                            src={pdfUrl}
                            className="h-full w-full"
                            style={{ border: "none" }}
                        />
                    ) : (
                        <div className="h-full w-full flex items-center justify-center text-sm text-slate-500">
                            ไม่พบไฟล์ PDF
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
}
